import React, { useEffect, useState } from 'react';

export default function IncomeStatementPage() {
  const [accountRegistry, setAccountRegistry] = useState({});
  const [auditLog, setAuditLog] = useState([]);

  useEffect(() => {
    const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');
    setAccountRegistry(registry);

    const allLogs = [];
    Object.keys(registry).forEach((email) => {
      const log = JSON.parse(localStorage.getItem(`paymentAuditLog_${email}`) || '[]');
      log.forEach((entry) => {
        allLogs.push({ ...entry, email });
      });
    });
    setAuditLog(allLogs);
  }, []);

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4">📊 Income Statement</h2>
      <p className="text-gray-600 mb-6">
        This module is tenant-aware and ready for audit-safe reporting.
      </p>

      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-100 text-sm text-gray-700">
            <th className="border px-3 py-2 text-left">Company</th>
            <th className="border px-3 py-2 text-left">Amount</th>
            <th className="border px-3 py-2 text-left">Currency</th>
            <th className="border px-3 py-2 text-left">Method</th>
            <th className="border px-3 py-2 text-left">Date</th>
          </tr>
        </thead>
        <tbody>
          {auditLog.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center py-4 text-gray-500 italic">
                No income records found.
              </td>
            </tr>
          ) : (
            auditLog.map((entry, index) => {
              const account = accountRegistry[entry.email] || {};
              return (
                <tr key={index} className="text-sm text-gray-800">
                  <td className="border px-3 py-2">{account.companyName}</td>
                  <td className="border px-3 py-2">{entry.amount}</td>
                  <td className="border px-3 py-2">{entry.currency}</td>
                  <td className="border px-3 py-2">{entry.paymentMethod}</td>
                  <td className="border px-3 py-2">{entry.purchaseDate}</td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
